import { useAuth0 } from '@auth0/auth0-react';
import { Actions, Loader, Stack, Text } from 'braid-design-system';

import { ChangePassword } from './components/ChangePassword.tsx';
import { Name } from './components/Name.tsx';
import { ResetSelfMfa } from './components/ResetSelfMfa.tsx';

import { BasePage } from '#src/components/BasePage/BasePage.tsx';
import type { Breadcrumb } from '#src/components/Breadcrumbs/Breadcrumbs.tsx';

export const UserProfilePage = ({
  breadcrumbs,
}: {
  breadcrumbs: Breadcrumb[];
}) => {
  const { user, isLoading } = useAuth0();

  return (
    <BasePage title="User profile" breadcrumbs={breadcrumbs}>
      {isLoading ? (
        <Loader />
      ) : (
        <Stack space="medium">
          <Name initialUsername={user?.name} />
          <Text>{user?.email}</Text>
          <Actions>
            <ResetSelfMfa />
            <ChangePassword />
          </Actions>
        </Stack>
      )}
    </BasePage>
  );
};
